import {Directive, ElementRef, forwardRef, HostListener, Input, OnInit, Renderer2} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[contentEditableToFormControl]',
  standalone: true,
  providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ContenteditableValueAccessorDirective),
            multi: true,
        },
    ],
})
/**
 * Allows a FormControl to be updated through an HTML element such as divs, spans etc.
 *
 * @example
 *  <span contentEditableToFormControl
 *        [allowHTMLTags]="false"
 *        formControlName="title"></span>
 *
 * @example
 *  <span contentEditableToFormControl
 *        [allowHTMLTags]="false"
 *        [(ngModel)]="myTityleVar"></span>
 *
 * @autor Carlos Duardo <carlos.duardo@qualud.com>
 */
export class ContenteditableValueAccessorDirective implements OnInit, ControlValueAccessor {

    @Input() allowHTMLTags = true;

    constructor(
        private readonly elementRef: ElementRef,
        private readonly renderer: Renderer2,
    ) {
    }

    ngOnInit(): void {
        this.elementRef.nativeElement.setAttribute('contenteditable', true);
    }

    private onTouched = () => {};

    private onChange: (value: string) => void = () => {};

    registerOnChange(onChange: (value: string) => void) {
        this.onChange = onChange;
    }

    registerOnTouched(onTouched: () => void) {
        this.onTouched = onTouched;
    }

    @HostListener('input')
    onInput() {
        const el = this.elementRef.nativeElement;
        this.onChange(this.allowHTMLTags ? el.innerHTML : el.textContent);
    }

    @HostListener('blur')
    onBlur() {
        this.onTouched();
    }

    setDisabledState(disabled: boolean) {
        this.setContentEditableState(disabled);
    }

    private setContentEditableState(disabled: boolean) {
        this.renderer.setAttribute(
            this.elementRef.nativeElement,
            'contenteditable',
            String(!disabled),
        );
    }

    writeValue(value: string) {
        this.renderer.setProperty(
            this.elementRef.nativeElement,
            'innerHTML',
            value,
        );
    }

}
